import React from 'react';
import LoggedLayout from '../../components/Layouts/LoggedLayout';
import MapList from '../../components/Map/List';
import { queries } from '../../graphql/graphql';

const ListPage = props => (
  <LoggedLayout>
    <MapList {...props} prefix="plan" queries={queries.PLANS} />
  </LoggedLayout>
);

export default ListPage;
